<template>
  <section class="pois">
    <span class="flex">
      <mvtDropdownList
          class="poi-dropdown"
          textAlign="left"
          size="small"
          v-model="selectedPoiCategory"
          :items="poiCategoryList"
      />
    </span>
    <div class="grid gap-3 lg-grid-cols-4 sm-grid-cols-3 xs-grid-cols-1">
      <poiCard v-for="item in getPoiList()" :key="item.placeName"
        :categoryName="item.categoryName"
        :categoryIcon="item.categoryIcon"
        :placeName="item.name"
        :address="item.address"
        :city="item.city"
        :state="item.state"
        :zip="item.zipcode?.replace(/-\d+/, '')"
      />
    </div>
  </section>
</template>

<script>
  import poiCard from '@/common/components/poi-card/poi-card.presentational.vue';
  import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';

  const poiCategoryIconMap = {
      'Grocery Stores': 'poi-grocery',
      'Shopping Centers': 'poi-shopping',
      Parks: 'poi-recreation',
      Cafes: 'poi-coffee',
      Restaurants: 'poi-eat',
      Transportation: 'poi-train',
  };


  export default {
    name: 'explorePois',
    props: {
      pois: {
          type: Array,
          required: true,
      },
    },
    components: {
      mvtDropdownList,
      poiCard,
    },
    data() {
      return {
        selectedPoiCategory: 'all',
      };
    },
    computed: {
      poiCategoryList() {
          const categories = Array.from(new Set(this.getPoiList('all').map((place) => place.categoryName)));
          return [
              {
                  text: 'All places',
                  value: 'all',
                  icon: 'icon-slider',
              },
              ...categories.map((cat) => ({
                  text: cat,
                  value: cat,
                  icon: `icon-${poiCategoryIconMap[cat] ?? 'pin'}`,
              })),
          ];
      },
    },
    methods: {
      getPoiList(poiCategory = this.selectedPoiCategory) {
          const populatedPoiCategories = this?.pois?.filter((category) => !!category?.list?.length) ?? [];
          let places = [];
          let i = 0;
          const numPlaces = this?.pois.reduce((acc, cat) => acc + cat.list.length, 0);
          while (places.length < numPlaces && i < numPlaces) {
              populatedPoiCategories.forEach((category) => {
                  const item = category?.list?.[i];
                  const containsPlaceByName = item?.name && places.map((place) => place.name).includes(item.name);
                  if (item && places.length < numPlaces && !containsPlaceByName) {
                      const categoryName = item.categoryName === 'Transits' ? 'Transportation' : item.categoryName;
                      places.push({
                          ...item,
                          categoryName,
                          categoryIcon: poiCategoryIconMap[categoryName] ?? 'pin',
                      });
                  }
              });
              i++;
          }
          // since we fetched more than we need for dupe mitigation, return only as many as we need
          return poiCategory === 'all' ? places : places.filter((place) => place.categoryName === this.selectedPoiCategory);
      },
    },
  };

</script>

<style lang="scss">
  .pois {
    display: flex;
    flex-direction: column;
    margin-top: .75rem !important;
    gap: 1rem;
    .icon-angle-down {
      display: none;
    }
  }
</style>